function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManageEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "709.883 -769.245 1776.304 1776.304",
    style: {
      shapeRendering: "geometricprecision"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#445ca9",
    d: "M905.5 20.5a9790.488 9790.488 0 0 0 83 83.5c1.558.21 2.891.71 4 1.5a832.578 832.578 0 0 0-55-4 4524.415 4524.415 0 0 1-80-80 782.545 782.545 0 0 1 48-1z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#475fab",
    d: "M905.5 20.5a800.175 800.175 0 0 1 115 7c32.97 33.465 66.13 66.799 99.5 100 .46.594.63 1.261.5 2a908.74 908.74 0 0 0-128-24c-1.109-.79-2.442-1.29-4-1.5a9790.488 9790.488 0 0 1-83-83.5z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#445aa8",
    d: "M857.5 21.5a4524.415 4524.415 0 0 0 80 80 385.046 385.046 0 0 0-32-1l-76-77a691.242 691.242 0 0 1 28-2z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#4059a7",
    d: "m829.5 23.5 76 77c-24.016.65-48.016 1.65-72 3a4.934 4.934 0 0 1-3-.5 6970.792 6970.792 0 0 1-70-70.5c22.8-4.21 45.8-7.21 69-9z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#4a60ac",
    d: "M1020.5 27.5c7.68.918 15.34 1.918 23 3a5137.888 5137.888 0 0 0 103.5 105c.46.594.63 1.261.5 2a807.228 807.228 0 0 1-27-8c.13-.739-.04-1.406-.5-2a14118.874 14118.874 0 0 1-99.5-100z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#4b62ad",
    d: "M1043.5 30.5a737.112 737.112 0 0 1 88 19c44.67 45 89.33 90 134 135a902.326 902.326 0 0 0-118-47c.13-.739-.04-1.406-.5-2a5137.888 5137.888 0 0 1-103.5-105z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#3b55a5",
    d: "M760.5 32.5a6970.792 6970.792 0 0 0 70 70.5 4.934 4.934 0 0 0 3 .5 1000.387 1000.387 0 0 0-88 13c-22.667-22-45-44.333-67-67a894.476 894.476 0 0 1 82-17z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#3751a2",
    d: "M678.5 49.5c22 22.667 44.333 45 67 67a279.444 279.444 0 0 1-32 7c-22-21.333-43.667-43-65-65a505.297 505.297 0 0 1 30-9z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#4e65af",
    d: "M1131.5 49.5c60.22 15.18 117.88 36.846 173 65 131 131.667 262.33 263 394 394 28.15 55.116 49.82 112.782 65 173-44.47-43.965-88.8-88.132-133-132.5a2.424 2.424 0 0 0-2-.5c-81.64-160.64-202.64-281.974-363-364-44.67-45-89.33-90-134-135z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#36509e",
    d: "M648.5 58.5c21.333 22 43 43.667 65 65a666.413 666.413 0 0 1-39 11l-63-64a598.513 598.513 0 0 1 37-12z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#334e99",
    d: "m611.5 70.5 63 64c-14.255 4.64-28.589 9.307-43 14a1380.54 1380.54 0 0 1-63-62 830.74 830.74 0 0 1 43-16z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#314b94",
    d: "M568.5 86.5a1380.54 1380.54 0 0 0 63 62 225.199 225.199 0 0 1-16 6 5042.129 5042.129 0 0 0-59.5-60 2.429 2.429 0 0 1-.5-2c4.261-1.984 8.594-3.984 13-6z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#304a90",
    d: "M555.5 92.5a2.429 2.429 0 0 0 .5 2 5042.129 5042.129 0 0 1 59.5 60 1014.82 1014.82 0 0 1-34 14l-61-60a286.818 286.818 0 0 1 35-16z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#15244b",
    d: "M905.5 100.5c10.685-.11 21.352.223 32 1a832.578 832.578 0 0 1 55 4 908.74 908.74 0 0 1 128 24c8.94 2.82 17.94 5.486 27 8a902.326 902.326 0 0 1 118 47c160.36 82.026 281.36 203.36 363 364a807.516 807.516 0 0 1 47 117 313.84 313.84 0 0 1 8 27 794.558 794.558 0 0 1 24 128 835.313 835.313 0 0 1 4 55 383.751 383.751 0 0 1 1 32 1726.64 1726.64 0 0 1-3 69c-3.29 30.36-7.62 60.69-13 91a267.61 267.61 0 0 0-7 32 670.4 670.4 0 0 0-11 39 811.79 811.79 0 0 0-14 43c-2.57 5.04-4.57 10.37-6 16a382.563 382.563 0 0 0-14 34c-7.3 15.26-14.63 30.6-22 46-5.17 8.34-9.84 17.01-14 26-4.15 5.63-7.82 11.63-11 18-10.3 15.98-20.63 31.98-31 48-11.3 14.98-22.64 29.98-34 45-10.3 11.97-20.64 23.97-31 36-16.33 17-33 33.67-50 50-16.03 13.7-32.03 27.36-48 41a615.145 615.145 0 0 0-27 20 1004.045 1004.045 0 0 1-72 46 908.323 908.323 0 0 1-72 36c-4.67 2-9.33 4-14 6a757.293 757.293 0 0 1-135 43c-4.61 1.25-9.27 2.25-14 3a876.622 876.622 0 0 1-124 16.5 7624.621 7624.621 0 0 1 73 73.5c-212.808 25.28-409.808-18.89-591-132.5C227.412 1520.78 98.911 1337.61 42 1103.5c-22.88-102.21-27.713-205.207-14.5-309a7579.086 7579.086 0 0 1 73.5 73 877.166 877.166 0 0 1 16.5-124 130.497 130.497 0 0 1 3-14 757.19 757.19 0 0 1 43-135l6-14a905.942 905.942 0 0 1 36-72 1004.084 1004.084 0 0 1 46-72 616.314 616.314 0 0 0 20-27c13.637-15.975 27.304-31.975 41-48 16.333-17 33-33.667 50-50a62267.808 62267.808 0 0 1 36-31 49711.654 49711.654 0 0 1 45-34 1698.32 1698.32 0 0 0 47-31 89.302 89.302 0 0 0 19-11 242.675 242.675 0 0 0 26-14c15.403-7.37 30.736-14.703 46-22a1014.82 1014.82 0 0 0 34-14 225.199 225.199 0 0 0 16-6c14.411-4.693 28.745-9.36 43-14a666.413 666.413 0 0 0 39-11 279.444 279.444 0 0 0 32-7 1000.387 1000.387 0 0 1 88-13c23.984-1.35 47.984-2.35 72-3z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#2f478c",
    d: "m520.5 108.5 61 60c-15.264 7.297-30.597 14.63-46 22a1250.723 1250.723 0 0 1-60-59 475.806 475.806 0 0 1 45-23z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.983
    },
    fill: "#5267b0",
    d: "M1304.5 114.5c163.92 83.749 290.75 206.082 380.5 367 4.53 9.053 9.03 18.053 13.5 27-131.67-131-263-262.333-394-394z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#2d4587",
    d: "M475.5 131.5a1250.723 1250.723 0 0 0 60 59 242.675 242.675 0 0 1-26 14l-59-58a461.722 461.722 0 0 1 25-15z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#2b4384",
    d: "m450.5 146.5 59 58a89.302 89.302 0 0 1-19 11c-19-19.667-38.333-39-58-58a123.08 123.08 0 0 1 18-11z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#29407f",
    d: "M432.5 157.5c19.667 19 39 38.333 58 58a1698.32 1698.32 0 0 1-47 31l-58-57a573.288 573.288 0 0 1 47-32z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#273c78",
    d: "m385.5 189.5 58 57a49711.654 49711.654 0 0 0-45 34 2299.866 2299.866 0 0 1-57-57 422.11 422.11 0 0 1 44-34z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#243972",
    d: "M341.5 223.5a2299.866 2299.866 0 0 0 57 57 62267.808 62267.808 0 0 0-36 31 1127.789 1127.789 0 0 1-57-56 95.356 95.356 0 0 1 8-8.5 915.585 915.585 0 0 1 28-23.5z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#22366d",
    d: "M305.5 255.5a1127.789 1127.789 0 0 0 57 56c-17 16.333-33.667 33-50 50l-57-56a589.786 589.786 0 0 1 50-50z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#203368",
    d: "m255.5 305.5 57 56a107229.463 107229.463 0 0 0-41 48 2299.866 2299.866 0 0 0-57-57 456.723 456.723 0 0 1 41-47z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#1e3264",
    d: "M214.5 352.5a2299.866 2299.866 0 0 1 57 57 616.314 616.314 0 0 1-20 27 2.428 2.428 0 0 1-2-.5 4382.789 4382.789 0 0 0-56-55.5 214.773 214.773 0 0 1 21-28z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#1d2f60",
    d: "M193.5 380.5a4382.789 4382.789 0 0 1 56 55.5 2.428 2.428 0 0 0 2 .5 1004.084 1004.084 0 0 0-46 72 1209.038 1209.038 0 0 1-59-58 622.408 622.408 0 0 1 47-70z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#1a2d5a",
    d: "M146.5 450.5a1209.038 1209.038 0 0 0 59 58 905.942 905.942 0 0 0-36 72 1292.635 1292.635 0 0 1-61-60c11.145-24.3 23.812-47.633 38-70z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#192a57",
    d: "M108.5 520.5a1292.635 1292.635 0 0 0 61 60l-6 14a2.428 2.428 0 0 1-2-.5 5042.129 5042.129 0 0 0-60-59.5l7-14z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#192854",
    d: "M101.5 534.5a5042.129 5042.129 0 0 1 60 59.5 2.428 2.428 0 0 0 2 .5 757.19 757.19 0 0 0-43 135l-67-66a936.082 936.082 0 0 1 48-129z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#4b62ad",
    d: "M1628.5 548.5c.74-.131 1.41.036 2 .5 44.2 44.368 88.53 88.535 133 132.5a737.122 737.122 0 0 1 19 88 5092.406 5092.406 0 0 1-105-103.5 2.424 2.424 0 0 0-2-.5 807.516 807.516 0 0 0-47-117z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2f4076",
    d: "M803.5 558.5h-142v538c-1-179.499-1.333-359.166-1-539 47.836-.332 95.503.001 143 1z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5368b1",
    d: "M803.5 558.5a40378.271 40378.271 0 0 1 90.5 262 987.78 987.78 0 0 1 12 42 7779.283 7779.283 0 0 0 24.5 99 2692.279 2692.279 0 0 1 33.5-131c30.167-91.003 61-181.669 92.5-272h144v538h-105c-.28-120.004.05-240.004 1-360 1.15-3.811 1.31-7.811.5-12a17.653 17.653 0 0 0-1.5 7 1467.777 1467.777 0 0 1-24.5 88 91918.563 91918.563 0 0 0-95.5 277h-91a71437.874 71437.874 0 0 0-96.5-277 1889.082 1889.082 0 0 1-25.5-88 20.093 20.093 0 0 0-1.5-6c-.819 6.181-.653 12.181.5 18 .426 9.667.926 19.333 1.5 29 .5 107.999.667 215.999.5 324h-102v-538h142z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#465a9b",
    d: "M1056.5 558.5c48.16-.999 96.5-1.332 145-1 .33 179.834 0 359.501-1 539v-538h-144z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#172651",
    d: "m53.5 663.5 67 66a130.497 130.497 0 0 0-3 14c-.617.111-1.117.444-1.5 1a2030.648 2030.648 0 0 0-66.5-65 214.948 214.948 0 0 0 4-16z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#4a60ac",
    d: "M1675.5 665.5c.74-.131 1.41.036 2 .5a5092.406 5092.406 0 0 0 105 103.5c1.08 7.656 2.08 15.322 3 23-33.47-32.965-66.8-66.132-100-99.5a2.424 2.424 0 0 0-2-.5 313.84 313.84 0 0 0-8-27z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#17264f",
    d: "M49.5 679.5a2030.648 2030.648 0 0 1 66.5 65c.383-.556.883-.889 1.5-1a877.166 877.166 0 0 0-16.5 124 7579.086 7579.086 0 0 0-73.5-73 795.425 795.425 0 0 1 22-115z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#475fab",
    d: "M1683.5 692.5c.74-.131 1.41.036 2 .5 33.2 33.368 66.53 66.535 100 99.5a799.442 799.442 0 0 1 7 115 9703.518 9703.518 0 0 1-83.5-83c-.21-1.558-.71-2.891-1.5-4a794.558 794.558 0 0 0-24-128z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5368b1",
    d: "M1622.5 1079.5v17h-98c-7.91-11.04-12.91-23.37-15-37-30.81 33.56-69.14 49.22-115 47-31.94 1.52-61.27-6.32-88-23.5-34.98-27.16-50.48-62.99-46.5-107.5 2.89-35.635 19.39-62.801 49.5-81.5 24.51-12.962 50.51-21.295 78-25 26.81-3.496 53.47-7.829 80-13 12.73-2.45 23.9-7.95 33.5-16.5 11.21-20.92 8.04-39.42-9.5-55.5-13.95-9.034-29.29-12.868-46-11.5-14.32-.946-27.99 1.554-41 7.5-14.02 8.187-22.52 20.354-25.5 36.5a373.503 373.503 0 0 0-1.5 17h-99c-.09-52 22.58-90.5 68-115.5 40.83-19.8 83.83-26.8 129-21 41.09 1.236 75.92 16.403 104.5 45.5 15.95 19.826 25.28 42.493 28 68 .33 77.333.67 154.667 1 232 .16 11.31 2.83 21.98 8 32 1.7 1.87 3.54 3.54 5.5 5z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#263767",
    d: "M1096.5 736.5c.28-1.915-.05-3.581-1-5 .02-2.427.52-4.76 1.5-7 .81 4.189.65 8.189-.5 12z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3d508d",
    d: "M762.5 731.5c-.983 3.798-1.317 7.798-1 12-1.153-5.819-1.319-11.819-.5-18a20.093 20.093 0 0 1 1.5 6z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#445ca9",
    d: "M1707.5 820.5c.79 1.109 1.29 2.442 1.5 4a9703.518 9703.518 0 0 0 83.5 83c.16 16.014-.18 32.014-1 48a4526.79 4526.79 0 0 1-80-80 835.313 835.313 0 0 0-4-55z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#445aa8",
    d: "M1711.5 875.5a4526.79 4526.79 0 0 0 80 80 688.531 688.531 0 0 1-2 28c-25.67-25.333-51.33-50.667-77-76 .11-10.685-.22-21.352-1-32z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#495d9f",
    d: "M1508.5 905.5c.06-.543.39-.876 1-1 1.33 17.829 1.33 35.495 0 53 .33-17.508 0-34.841-1-52z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#4059a7",
    d: "M1712.5 907.5c25.67 25.333 51.33 50.667 77 76-1.79 23.2-4.79 46.2-9 69a7044.63 7044.63 0 0 1-70.5-70c-.5-1.973-.66-3.973-.5-6a1726.64 1726.64 0 0 0 3-69z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#15244b",
    d: "M1508.5 905.5c1 17.159 1.33 34.492 1 52-5.1 39.934-27.43 64.1-67 72.5-17.18 2.51-34.18 1.85-51-2-18.95-7.72-27.95-21.88-27-42.5-.7-17.106 6.3-29.94 21-38.5a190.199 190.199 0 0 1 29-11 738.683 738.683 0 0 0 82-21 59.138 59.138 0 0 0 9-5c1.64-1.129 2.64-2.629 3-4.5z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#3b55a5",
    d: "M1709.5 976.5c-.16 2.027 0 4.027.5 6a7044.63 7044.63 0 0 0 70.5 70 894.679 894.679 0 0 1-17 82c-22.67-22-45-44.33-67-67 5.38-30.31 9.71-60.64 13-91z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#3751a2",
    d: "M1696.5 1067.5c22 22.67 44.33 45 67 67a506.646 506.646 0 0 1-9 30c-22-21.33-43.67-43-65-65a267.61 267.61 0 0 1 7-32z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#394c87",
    d: "M1622.5 1079.5c.99 5.81 1.32 11.81 1 18-33.17.33-66.17 0-99-1h98v-17z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#36509e",
    d: "M1689.5 1099.5c21.33 22 43 43.67 65 65-3.6 12.47-7.6 24.81-12 37-21.33-21-42.67-42-64-63a670.4 670.4 0 0 1 11-39z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#334e99",
    d: "M1678.5 1138.5c21.33 21 42.67 42 64 63a827.096 827.096 0 0 1-16 43 1379.044 1379.044 0 0 1-62-63 811.79 811.79 0 0 1 14-43z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#314b94",
    d: "M1664.5 1181.5c19.95 21.62 40.62 42.62 62 63-2 4.33-4 8.67-6 13-.74.13-1.41-.04-2-.5a5019.227 5019.227 0 0 0-60-59.5c1.43-5.63 3.43-10.96 6-16z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#304a90",
    d: "M1658.5 1197.5c20.13 19.63 40.13 39.46 60 59.5.59.46 1.26.63 2 .5a287.605 287.605 0 0 1-16 35c-20-20.33-40-40.67-60-61 4.15-11.62 8.81-22.95 14-34z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#2f478c",
    d: "M1644.5 1231.5c20 20.33 40 40.67 60 61a476.053 476.053 0 0 1-23 45 1249.843 1249.843 0 0 1-59-60c7.37-15.4 14.7-30.74 22-46z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#2d4587",
    d: "M1622.5 1277.5c18.95 20.62 38.62 40.62 59 60a459.03 459.03 0 0 1-15 25c-19.33-19.67-38.67-39.33-58-59 4.16-8.99 8.83-17.66 14-26z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#2b4384",
    d: "M1608.5 1303.5c19.33 19.67 38.67 39.33 58 59-3.17 6.34-6.83 12.34-11 18-19.33-19.67-38.67-39.33-58-59 3.18-6.37 6.85-12.37 11-18z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#29407f",
    d: "M1597.5 1321.5c19.33 19.67 38.67 39.33 58 59a573.128 573.128 0 0 1-32 47c-19-19.33-38-38.67-57-58 10.37-16.02 20.7-32.02 31-48z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#273c78",
    d: "M1566.5 1369.5c19 19.33 38 38.67 57 58a422.731 422.731 0 0 1-34 44 2320.77 2320.77 0 0 1-57-57c11.36-15.02 22.7-30.02 34-45z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#243972",
    d: "M1532.5 1414.5a2320.77 2320.77 0 0 0 57 57 621.045 621.045 0 0 1-32 36 1126.998 1126.998 0 0 1-56-57c10.36-12.03 20.7-24.03 31-36z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#22366d",
    d: "M1501.5 1450.5c17.95 19.62 36.62 38.62 56 57a589.786 589.786 0 0 1-50 50c-18.67-19-37.33-38-56-57 17-16.33 33.67-33 50-50z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#203368",
    d: "M1451.5 1500.5c18.67 19 37.33 38 56 57a456.181 456.181 0 0 1-47 41 2320.77 2320.77 0 0 0-57-57c15.97-13.64 31.97-27.3 48-41z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#1e3264",
    d: "M1403.5 1541.5a2320.77 2320.77 0 0 1 57 57c-8.76 7.76-18.1 14.76-28 21-18.3-18.8-36.8-37.47-55.5-56-.46-.59-.63-1.26-.5-2 8.81-6.91 17.81-13.57 27-20z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#1d2f60",
    d: "M1376.5 1561.5c-.13.74.04 1.41.5 2 18.7 18.53 37.2 37.2 55.5 56a622.5 622.5 0 0 1-70 47 1212.686 1212.686 0 0 1-58-59c24.71-14.35 48.71-29.68 72-46z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#1a2d5a",
    d: "M1304.5 1607.5c18.62 20.28 37.95 39.95 58 59-22.37 14.19-45.7 26.85-70 38a1292.123 1292.123 0 0 1-60-61 908.323 908.323 0 0 0 72-36z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#192a57",
    d: "M1232.5 1643.5c19.28 20.95 39.28 41.28 60 61-4.6 2.3-9.27 4.63-14 7a5019.227 5019.227 0 0 0-59.5-60c-.46-.59-.63-1.26-.5-2 4.67-2 9.33-4 14-6z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#192854",
    d: "M1218.5 1649.5c-.13.74.04 1.41.5 2 20.04 19.87 39.87 39.87 59.5 60a937.038 937.038 0 0 1-129 48c-22-22.33-44-44.67-66-67a757.293 757.293 0 0 0 135-43z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#172651",
    d: "M1083.5 1692.5c22 22.33 44 44.67 66 67-5.39 1.13-10.72 2.46-16 4a2034.623 2034.623 0 0 0-65-66.5c.56-.38.89-.88 1-1.5 4.73-.75 9.39-1.75 14-3z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#17264f",
    d: "M1069.5 1695.5c-.11.62-.44 1.12-1 1.5 22.25 21.75 43.92 43.92 65 66.5a795.227 795.227 0 0 1-115 22 7624.621 7624.621 0 0 0-73-73.5 876.622 876.622 0 0 0 124-16.5z",
    transform: "matrix(1, 0, 0, 1, 691.480347, -787.056152)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageEdit);
export default __webpack_public_path__ + "static/media/ManageEdit.57623db89bd643651ed03b4728f8527b.svg";
export { ForwardRef as ReactComponent };